import type {
  Course,
  CourseCategoryData,
} from '@jobseeker/common-core/types/course';

const mapCourseCategoryDataToCourse = (
  categoryData: Partial<CourseCategoryData>[]
): Partial<Course>[] => {
  return categoryData.map(data => {
    return {
      id: data.id,
      title: data.title,
      fee: data.fee,
      duration: data.duration,
      minWorkExp: data.minWorkExp,
      maxWorkExp: data.maxWorkExp,
      deliveryMethod: data.deliveryMethod,
      path: data.logo,
      institute: data.institute,
      location: data.locationArr,
      redirectUrl: data.redirect_url,
      premiumFlag: data.premiumFlag,
      views: data.Views,
      brochure: data.brochure,
      oneLiner: data.oneLiner,
      lg_partner_url: data.lg_partner_url,
      courseImage: data.Logo || data.logo,
      courseImageCDN: data.Logo || data.logo,
      surveyEnabled: data.surveyEnabled,
    };
  });
};

export {mapCourseCategoryDataToCourse};
